<template>
  <div class="remodal" :data-remodal-id="'modal-'+(item.BookID || newestID)" v-if="item">
    <a data-remodal-action="close" class="remodal-close"></a>
    <div class="col-md-4"><img title="" :src="item.CoverURL || item.BookCoverURL" /></div>
    <div class="col-md-8">
        <div class="checkout_title">{{item.Title || item.BookTitle}}</div>
        <div class="checkout_word">{{item.Vol || item.BookVolName}}</div>
        <div class="checkout_word" v-if="item.BookPrice">共花費：</div>
        <div class="checkout_coin_wrap" v-if="item.BookPrice">
            <div class="donli_coin coin_word_info coinAndPoint" v-if="item.BookPrice.OrgPrice != item.BookPrice.Price">
                <span class="price_oldSale">{{item.BookPrice.OrgPrice}}</span>
                &nbsp;{{item.BookPrice.Price}}
                <span class="coin_word coin_word_info">東立幣</span>
            </div>
            <div class="donli_coin coinAndPoint" v-if="item.BookPrice.OrgPrice == item.BookPrice.Price">
                {{item.BookPrice.OrgPrice}}
                <span class="coin_word">東立幣</span>
            </div>
        </div>
        <div class="checkout_word" v-if="item.BookPrice">購買可獲得：</div>
        <div class="checkout_coin_wrap" v-if="item.BookPrice">
            <div class="bonuspoint coin_word_info coinAndPoint" v-if="item.BookPrice.OrgBonus != item.BookPrice.Bonus">
                <span class="bonus_oldSale">{{item.BookPrice.OrgBonus}}</span>
                {{item.BookPrice.Bonus}}
                <span class="coin_word coin_word_info">紅利點數</span>
            </div>
            <div class="bonuspoint coinAndPoint" v-if="item.BookPrice.OrgBonus == item.BookPrice.Bonus">
                {{item.BookPrice.Bonus}}
                <span class="coin_word">紅利點數</span>
            </div>
        </div>
        <div class="checkout_coin_wrap" v-if="item.BookPrice"><a data-remodal-action="close"><div class="page_btn" @click="quickPurchase(item.BookID)">確認購買</div></a></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL,sourceTree} from './config.js'
import cart from './cart.js'

export default {
  name: 'Remodal',
  props: ["book","newestID"],
  data () {
    return {
      initRemodaled: true,
      item: this.book,
      newestID : this.newestID,
      isUpdate:false
    }
  },
  methods: {
    ...cart,
    //  quickBuy () {
    //   console.log(this.book.BookID)
    // }
    getBook(bookID){
      axios.get(`${API_URL}/Book?bookID=`+bookID, this.getBearerToken()).then(response => {
        this.item = response.data
        this.isUpdate = true
      })
    },
    getBearerToken: function () {
      return {
        headers: {'Authorization': 'bearer ' + sourceTree.token}
      }
    }
  },
  mounted () {
    // this.newestID=="" ? "" : this.getBook(this.newestID)
    $('[data-remodal-id=modal-'+(this.item.BookID || this.newestID)+']').remodal()
    // console.log('mounted')
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // if(!this.newestID&&!this.item.BookID){
    //   console.log(this.item.BookTitle+" this.newestID is nothing")
    //   this.getNewestBookID(this.book).then(response =>{
    //     console.log(this.book.BookTitle+'[data-remodal-id=modal-'+(this.item.BookID || this.newestID) +']')
    //     $('[data-remodal-id=modal-'+(this.item.BookID || this.newestID)+']').remodal()
    //   })
    // }else{
    //   console.log(this.book.BookTitle+'[data-remodal-id=modal-'+(this.item.BookID || this.newestID) +']')
    //   $('[data-remodal-id=modal-'+(this.item.BookID || this.newestID)+']').remodal()
    // }
  },
  updated(){
    // console.log("updated "+this.newestID)
    if(this.newestID&&!this.isUpdate) this.getBook(this.newestID)
  }
}
</script>



// WEBPACK FOOTER //
// src/Remodal.vue